import { useIntl } from 'react-intl'
import styled from 'styled-components'
import Group from 'components/utils/Group'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import FilterChip from 'LuxKit/Chips/FilterChip'
import LineMapIcon from 'LuxKit/Icons/line/LineMapIcon'
import type { HotelListingDrawerHeaderProps } from './types'

const TitleGroup = styled(Group)`
  flex: 1;
  min-width: 0;
`

function HotelListingDrawerHeader({
  placeName,
  placeCountry,
  onExploreMap,
}: HotelListingDrawerHeaderProps) {
  const intl = useIntl()

  return (
    <Group
      direction="horizontal"
      gap={16}
      horizontalAlign="space-between"
      verticalAlign="start"
    >
      <TitleGroup direction="vertical" gap={4}>
        <Heading variant="heading2">
          {intl.formatMessage(
            {
              id: 'G-nNmBr53dHAL8cBtSNe',
              defaultMessage: 'Hotels in {placeName}',
              description: 'Heading for hotel listing drawer showing hotels in a specific place',
            },
            { placeName },
          )}
        </Heading>
        <BodyText variant="medium" colour="neutral-two">
          {intl.formatMessage(
            {
              id: '1AhR5yM5BWuUDRQPUrWC',
              defaultMessage: '{placeName}, {placeCountry}',
              description: 'Hotel listing drawer header place name and country separated by comma',
            },
            { placeName, placeCountry },
          )}
        </BodyText>
      </TitleGroup>

      <FilterChip
        size="medium"
        startIcon={<LineMapIcon />}
        onClick={onExploreMap}
      >
        {intl.formatMessage({
          id: 'nLiQXIYCc1hnkMYEEhG4',
          defaultMessage: 'Explore more',
          description: 'Action button label to explore more hotels on the map',
        })}
      </FilterChip>
    </Group>
  )
}

export default HotelListingDrawerHeader
